// import React from 'react';
// import { Link } from 'react-router-dom';
// import { useQuery } from 'react-query';
// import { ArrowRight, Wrench } from 'lucide-react';
// import { serviceService } from '../../../services/serviceService';
// import FadeIn from '../../../components/animations/FadeIn';

// const ServicesPreview = () => {
//   const {
//     data: services = [],
//     isLoading,
//     isError,
//   } = useQuery(
//     ['servicesPreview'],
//     () => serviceService.getAllPublic(), // ✅ FIXED (was getAll)
//     { staleTime: 30 * 1000 }
//   );

//   if (isLoading) {
//     return (
//       <section className="py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center">
//             <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   if (isError) {
//     return (
//       <section className="py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center text-red-500">
//             Failed to load services
//           </div>
//         </div>
//       </section>
//     );
//   }

//   const servicesList = Array.isArray(services) ? services : [];

//   // ✅ If featured exists, show featured first, otherwise latest 3
//   const featured = servicesList.filter((s) => s.featured === true);
//   const featuredServices = (featured.length > 0 ? featured : servicesList).slice(0, 3);

//   return (
//     <section className="py-20 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <FadeIn>
//           <div className="text-center mb-12">
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               Our Services
//             </h2>
//             <p className="text-lg text-gray-600 max-w-2xl mx-auto">
//               Professional IoT and embedded solutions tailored to your needs
//             </p>
//           </div>
//         </FadeIn>

//         {featuredServices.length === 0 ? (
//           <div className="text-center text-gray-500 py-12">
//             No services available
//           </div>
//         ) : (
//           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {featuredServices.map((service, index) => (
//               <FadeIn key={service._id} delay={index * 0.1}>
//                 <div className="group bg-gradient-to-br from-gray-50 to-white p-8 rounded-3xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
//                   <div className="w-14 h-14 bg-primary-100 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary-500 transition-colors">
//                     <Wrench className="w-7 h-7 text-primary-600 group-hover:text-white transition-colors" />
//                   </div>

//                   <h3 className="text-xl font-bold text-gray-900 mb-3">
//                     {service.title}
//                   </h3>

//                   <p className="text-gray-600 mb-6 line-clamp-3">
//                     {service.shortDescription}
//                   </p>

//                   <Link
//                     to={`/services/${service.slug}`}
//                     className="inline-flex items-center text-primary-600 font-semibold hover:text-primary-700 transition-colors"
//                   >
//                     Learn More
//                     <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
//                   </Link>
//                 </div>
//               </FadeIn>
//             ))}
//           </div>
//         )}

//         <FadeIn delay={0.4}>
//           <div className="text-center mt-12">
//             <Link
//               to="/services"
//               className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-primary-500 to-accent text-white font-semibold rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300"
//             >
//               View All Services
//               <ArrowRight className="ml-2 w-5 h-5" />
//             </Link>
//           </div>
//         </FadeIn>
//       </div>
//     </section>
//   );
// };

// export default ServicesPreview;




import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import FadeIn from '../../../components/animations/FadeIn';

const ServicesPreview = () => {
  // Static data for three cards - MODIFY THESE VALUES
  const services = [
    {
      id: 1,
      title: 'Hardware Solutions',
      shortDescription: `SiWi's hardware engineering capabilities span the entire product lifecycle from concept design to mass manufacturing. Our in-house R&D team develops specialized GPS tracking devices that withstand the harshest operational environments, including extreme temperatures, constant vibration, water immersion, and dust exposure. The E-Rutu vehicle tracker exemplifies our design philosophy—integrating 4G/2G cellular, BLE 5.1 mesh, temperature sensors, and door monitoring in a compact IP67-rated enclosure that survives automotive underhood conditions.....`,
      image: '/assets/images/Device1.png',
      label: 'Device Manufacturing',
      icon: '/assets/images/serviceicon1.png',
      link: '/services'
    },
    {
      id: 2,
      title: 'Expert Support',
      shortDescription: `SiWi's customer success organization delivers comprehensive support spanning technical assistance, strategic consulting, and training programs. Our technical support center operates 24/7/365 with multilingual engineers available via phone, email, live chat, and remote diagnostics tools that accelerate issue resolution. Enterprise clients receive dedicated account managers who understand their operational context and provide proactive guidance on optimization opportunities...`,
      image: '/assets/images/service2.png',
      label: 'Support & Consulting',
      icon: '/assets/images/serviceicon2.png',
      link: '/services'
    },
    {
      id: 3,
      title: 'Software Solutions',
      shortDescription: `Empower your workforce with native iOS and Android applications designed for field operations. Drivers access navigation, delivery confirmation, and digital proof-of-capture tools, while managers monitor fleet status and receive critical alerts on-the-go. White-label options present your brand identity to customers and employees. Offline functionality ensures productivity in connectivity dead zones, with automatic synchronization when networks restore. Custom features adapt to your specific workflow requirements.`,
      image: '/assets/images/service3.png',
      label: 'SOFTWARE DEVELOPMENT',
      icon: '/assets/images/serviceicon3.png',
      link: '/services'
    }
  ];

  return (
    <section className="pt-8 pb-20 md:pt-10 md:pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* ✅ Header + Full Text */}
        <FadeIn>
          <div className="oem-head text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight uppercase text-gray-900/80">
              EXPERTISE WE PROVIDE....
            </h2>

            <div className="mt-6 max-w-5xl mx-auto space-y-6">
              <p className="text-base md:text-lg lg:text-xl text-gray-500 leading-relaxed">
                SiWi delivers end-to-end location intelligence solutions that transform how businesses monitor,
                manage, and optimize mobile assets. From rugged hardware manufacturing to software platforms,
                mobile applications to system integration, our comprehensive service portfolio addresses every
                aspect of your tracking ecosystem. Discover how our expertise drives operational efficiency,
                reduces costs, and mitigates risks across industries worldwide.
              </p>
            </div>
          </div>
        </FadeIn>

        {/* ✅ Three Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 items-start">
          {services.map((service, index) => (
            <FadeIn key={service.id} delay={index * 0.1}>
              <div className="h-full">
                <Link
                  to={service.link}
                  onClick={() => window.scrollTo(0, 0)}
                  className="group block"
                >
                  {/* ✅ Card shell (Solutions-like border + shadow) - slightly shorter height */}
                  <div className="relative overflow-hidden bg-white border border-gray-200 hover:border-gray-300 hover:shadow-xl transition-all duration-300 h-[440px]">
                    {/* ✅ Default: only image */}
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                      onError={(e) => {
                        e.currentTarget.src = '/assets/images/banner3.png';
                      }}
                    />

                    {/* ✅ Hover: curved layer slides up */}
                    <div
                      className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out z-10"
                      style={{ height: '75%' }}
                    >
                      {/* ✅ Curved background (gray + white mixed gradient) */}
                      <svg
                        className="absolute inset-0 w-full h-full"
                        viewBox="0 0 340 360"
                        preserveAspectRatio="none"
                      >
                        <defs>
                          <linearGradient id={`gradient-${service.id}`} x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" stopColor="rgba(243,244,246,0.95)" />
                            <stop offset="40%" stopColor="rgba(229,231,235,0.97)" />
                            <stop offset="70%" stopColor="rgba(255,255,255,0.98)" />
                            <stop offset="100%" stopColor="rgba(255,255,255,1)" />
                          </linearGradient>
                        </defs>

                        {/* ✅ U-shaped curve */}
                        <path
                          d="M0,100 Q170,0 340,100 L340,360 L0,360 Z"
                          fill={`url(#gradient-${service.id})`}
                        />
                      </svg>

                      {/* ✅ Content on overlay */}
                      <div className="absolute inset-0 flex flex-col items-center justify-start pt-8 px-5 text-center">
                        {/* Icon */}
                        <div className="mb-4 w-24 h-24 flex items-center justify-center mt-3">
                          <img
                            src={service.icon}
                            alt={service.title}
                            className="w-20 h-20 object-contain"
                            loading="eager"
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.style.display = 'none';
                            }}
                          />
                        </div>

                        {/* Title */}
                        <h3 className="text-lg font-semibold text-gray-900 mb-2 uppercase tracking-wide text-center">
                          {service.title}
                        </h3>

                        {/* Description */}
                        <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-4">
                          {service.shortDescription}
                        </p>

                        {/* Learn More */}
                        <div className="inline-flex items-center text-gray-900 font-bold uppercase tracking-widest text-xs border-b-2 border-gray-900 pb-1 transition-colors hover:text-gray-600">
                          Learn More <ArrowRight className="ml-2 w-3 h-3" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* ✅ Label outside card */}
                  <div className="mt-4 text-center">
                    <h4 className="text-sm font-bold text-gray-900 uppercase tracking-wider">
                      {service.label}
                    </h4>
                  </div>
                </Link>
              </div>
            </FadeIn>
          ))}
        </div>

        {/* ✅ Bottom Button */}
        <FadeIn delay={0.4}>
          <div className="text-center mt-20">
            <Link
              to="/services"
              onClick={() => window.scrollTo(0, 0)}
              className="inline-flex items-center justify-center min-w-[240px] h-12 px-8
                        border border-gray-900 text-gray-900 bg-transparent
                        font-semibold tracking-wide uppercase text-sm
                        transition-all duration-300
                        hover:bg-gray-900 hover:text-white"
            >
              Explore Services
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </div>
        </FadeIn>
      </div>

      {/* CSS for line clamp */}
      <style jsx>{`
        .line-clamp-4 {
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </section>
  );
};

export default ServicesPreview;